import { AlertTriangle } from "lucide-react"
import { Button } from "../ui/button"

export default function ConfirmModal({ 
  isOpen, 
  onClose, 
  title = "Confirmer l'action",
  message,
  confirmText = "Confirmer",
  cancelText = "Annuler",
  variant = "danger", // danger, warning, info
  onConfirm 
}) {
  if (!isOpen) return null

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  const variantStyles = {
    danger: "text-gray-700 bg-gray-100",
    warning: "text-gray-700 bg-gray-100",
    info: "text-[#203a8a] bg-blue-50"
  }

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start gap-4 mb-4">
          <div className={`p-3 rounded-full ${variantStyles[variant]}`}>
            <AlertTriangle className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              {title}
            </h2>
            <p className="text-gray-600">
              {message}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            className={
              variant === 'danger' 
                ? "bg-gray-700 hover:bg-gray-800 text-white"
                : variant === 'warning'
                ? "bg-gray-700 hover:bg-gray-800 text-white"
                : "bg-[#203a8a] hover:bg-[#1a2f6e] text-white"
            }
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  )
}

